import React, { useEffect } from "react";
import { GiveawayActive, GiveawayArchieve } from "../../types";
import ActiveGiveawayInfo from "./components/ActiveGiveawayInfo/ActiveGiveawayInfo";
import FinishedGiveawayInfo from "./components/FinishedGiveawayInfo/FinishedGiveawayInfo";

interface GiveawayInfoProps {
  giveaway: GiveawayActive | GiveawayArchieve;
  handleExpired: () => void;
  handleOpenDCModal: () => void;
  handleOpenStarModal: () => void;
  handleClaim: (place: number) => void;
  isVisible: boolean;
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
  userID: number;
  tg: any;
}

export const GiveawayInfo: React.FC<GiveawayInfoProps> = ({
  giveaway,
  handleExpired,
  handleOpenDCModal,
  handleOpenStarModal,
  handleClaim,
  isVisible,
  currentSlide,
  setCurrentSlide,
  userID,
  tg,
}) => {
  if (giveaway.status === "active" || giveaway.status === "winner_selection") {
    return (
      <ActiveGiveawayInfo
        giveaway={giveaway as GiveawayActive}
        handleExpired={handleExpired}
        handleOpenDCModal={handleOpenDCModal}
        handleOpenStarModal={handleOpenStarModal}
        tg={tg}
      />
    );
  } else {
    return (
      <FinishedGiveawayInfo
        giveaway={giveaway as GiveawayArchieve}
        handleClaim={handleClaim}
        isVisible={isVisible}
        currentSlide={currentSlide}
        setCurrentSlide={setCurrentSlide}
        userID={userID}
        tg={tg}
      />
    );
  }
};
